import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { StarRating } from '../../../../components/Sessions/Elements/StarRating';

export const SessionDetailRating = ({ rating, setRating, isRatingSubmitted, onSubmitRating }) => {
    return (
        <Row className="g-4 mt-4">
            <Col xs={12}>
                <h6 className="text-muted">Language Proficiency Rating</h6>
                <div className="px-1 pb-2">
                    <div className="d-flex align-items-center">
                        <StarRating value={rating} onChange={setRating}/>
                        {!isRatingSubmitted && (
                            <Button variant="primary" className="ms-3" onClick={onSubmitRating}>
                                Submit Rating
                            </Button>
                        )}
                    </div>
                </div>
            </Col>
        </Row>
    );
};